import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import paymentDetails from './views/payment-details'

export default [
  {
    path: RoutePathConstants.PAYMENT_DETAILS,
    name: 'paymentDetails',
    component: paymentDetails
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/payment-details/routers.js